const Line = () => {
    return (
        <div className="w-full h-[1px] bg-Gray/5">
        </div>
    );
}

export default Line;
